
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AdmissionForm.css";

function AdmissionForm() {
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPhoto(file);
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <main className="admission-page mt-5">


      {/* FORM */}
      <section className="admission-form-section">
        <div className="container">

          <form
            className="admission-form mt-5"
            onSubmit={(e) => {
              e.preventDefault();
              alert("Form completed. Please use Print Form to save or print it. Online submission is not connected yet.");
            }}
          >

            {/* FORM HEADER */}
            <div className="admission-form-header">

              <div className="student-photo-box">
                {photoPreview ? (
                  <img src={photoPreview} alt="Student preview" />
                ) : (
                  <>
                    <i className="bi bi-person-fill"></i>
                    <span>Student Photo</span>
                  </>
                )}

                <label className="photo-upload no-print">
                  <i className="bi bi-camera-fill"></i>
                  Upload
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoChange}
                  />
                </label>
              </div>

              <div className="school-form-heading">
                <span className="form-school-name">AIR FORCE SCHOOL</span>
                <h2>Vayu Sena Nagar, Nagpur</h2>
                <p>Phone No. 0712 - 2511407</p>
                <p className="cbse-number">CBSE AFFILIATION NO: 1130860</p>
                <h1>ADMISSION FORM</h1>
                <div className="session-field">
                  <label htmlFor="session">Session:</label>
                  <input id="session" name="session" placeholder="Enter academic session" />
                </div>
              </div>

              <div className="admission-numbers">
                <label>Sr. No.</label>
                <input name="serialNumber" placeholder="________" />
                <label>Adm. No.</label>
                <input name="admissionNumber" placeholder="________" />
              </div>

            </div>

            <div className="form-instruction">
              Please fill in all applicable details clearly.
              Fields marked with * are required.
            </div>

            {/* STUDENT DETAILS */}
            <div className="admission-section-heading">
              <span>01</span>
              <h3>Student Information</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field">
                <label>1. Class to which admission is sought *</label>
                <select name="classSought" required defaultValue="">
                  <option value="" disabled>Select Class</option>
                  <option>LKG</option>
                  <option>UKG</option>
                  {["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"].map((item) => (
                    <option key={item}>Class {item}</option>
                  ))}
                </select>
              </div>

              <div className="admission-field">
                <label>2. Full Name of Child *</label>
                <input name="childName" placeholder="Enter child's full name" required />
              </div>

              <div className="admission-field">
                <label>3. Date of Birth – In Figures *</label>
                <input type="date" name="dobFigures" required />
              </div>

              <div className="admission-field">
                <label>Date of Birth – In Words</label>
                <input name="dobWords" placeholder="Enter date of birth in words" />
              </div>

              <p className="form-hint full-width">
                Attach Date of Birth Certificate and T.C. as applicable.
              </p>

              <div className="admission-field age-fields">
                <label>4. Age as on 1st April</label>
                <div className="age-inputs">
                  <input type="number" name="ageYears" min="0" placeholder="Years" />
                  <input type="number" name="ageMonths" min="0" max="11" placeholder="Months" />
                  <input type="number" name="ageDays" min="0" max="31" placeholder="Days" />
                </div>
              </div>

              <div className="admission-field two-column-field">
                <div>
                  <label>5. Caste</label>
                  <input name="caste" placeholder="Enter caste" />
                </div>
                <div>
                  <label>Religion</label>
                  <input name="religion" placeholder="Enter religion" />
                </div>
              </div>

            </div>

            {/* PARENT DETAILS */}
            <div className="admission-section-heading">
              <span>02</span>
              <h3>Parent & Guardian Information</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field">
                <label>6. Father's Name and Education *</label>
                <input name="fatherDetails" placeholder="Father's full name and education" required />
              </div>

              <div className="admission-field">
                <label>7. Mother's Name and Education *</label>
                <input name="motherDetails" placeholder="Mother's full name and education" required />
              </div>

              <div className="admission-field">
                <label>8. Present / Residential Address *</label>
                <textarea name="residentialAddress" rows="2" placeholder="Enter complete residential address" required />
              </div>

            </div>

            {/* EMPLOYMENT DETAILS */}
            <div className="admission-section-heading">
              <span>03</span>
              <h3>Employment & Defence Details</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field">
                <label>9(a). Whether a Defence Employee?</label>
                <div className="radio-options">
                  <label><input type="radio" name="defenceEmployee" value="Yes" /> Yes</label>
                  <label><input type="radio" name="defenceEmployee" value="No" /> No</label>
                </div>
                <input name="defenceRank" placeholder="If yes, mention rank" />
              </div>

              <div className="admission-field">
                <label>9(b). Whether belongs to Air Force?</label>
                <div className="radio-options">
                  <label><input type="radio" name="airForce" value="Yes" /> Yes</label>
                  <label><input type="radio" name="airForce" value="No" /> No</label>
                </div>
                <input name="airForceDetails" placeholder="If yes, mention rank and unit" />
              </div>

              <div className="admission-field">
                <label>9(c). Whether a Central Govt. Employee?</label>
                <div className="radio-options">
                  <label><input type="radio" name="centralGovt" value="Yes" /> Yes</label>
                  <label><input type="radio" name="centralGovt" value="No" /> No</label>
                </div>
                <input name="centralGovtDetails" placeholder="Mention designation and department" />
              </div>

              <div className="admission-field">
                <label>10. Office Address</label>
                <textarea name="officeAddress" rows="2" placeholder="Enter office address" />
              </div>

            </div>

            {/* CONTACT DETAILS */}
            <div className="admission-section-heading">
              <span>04</span>
              <h3>Contact & Financial Information</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field three-column-field">
                <div>
                  <label>11. Phone No. Residence</label>
                  <input type="tel" name="residencePhone" placeholder="Phone number" />
                </div>
                <div>
                  <label>Alternate WhatsApp No.</label>
                  <input type="tel" name="whatsappNumber" placeholder="WhatsApp number" />
                </div>
                <div>
                  <label>Office Phone</label>
                  <input type="tel" name="officePhone" placeholder="Office number" />
                </div>
              </div>

              <div className="admission-field">
                <label>12. Monthly Income of Father</label>
                <input type="number" name="fatherIncome" placeholder="Enter monthly income" />
              </div>

              <div className="admission-field">
                <label>13. Name and Address of Local Guardian, if any</label>
                <textarea name="localGuardian" rows="2" placeholder="Enter guardian name and address" />
              </div>

            </div>

            {/* PREVIOUS SCHOOL */}
            <div className="admission-section-heading">
              <span>05</span>
              <h3>Previous School & Academic Details</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field">
                <label>14(a). Name of the Past School Attended</label>
                <input name="previousSchool" placeholder="Enter previous school name" />
              </div>

              <div className="admission-field">
                <label>14(b). Class in which studying and Method of Instruction</label>
                <input name="previousClass" placeholder="Enter class and method of instruction" />
              </div>

              <div className="admission-field three-column-field">
                <div>
                  <label>15. Result of Last Examination (%)</label>
                  <input type="number" name="examPercentage" min="0" max="100" placeholder="Percentage" />
                </div>
                <div>
                  <label>Marks Obtained</label>
                  <input type="number" name="marksObtained" placeholder="Obtained" />
                </div>
                <div>
                  <label>Marks Out Of</label>
                  <input type="number" name="marksOutOf" placeholder="Total marks" />
                </div>
              </div>

              <div className="admission-field">
                <label>16. Whether it was a Central School / AF School / Recognised School</label>
                <input name="schoolType" placeholder="Mention school category" />
              </div>

              <div className="admission-field">
                <label>17. Mother Tongue</label>
                <input name="motherTongue" placeholder="Enter mother tongue" />
              </div>

            </div>

            {/* IDENTIFICATION */}
            <div className="admission-section-heading">
              <span>06</span>
              <h3>Identification & Documents</h3>
            </div>

            <div className="admission-fields">

              <div className="admission-field full-width">
                <label>18. Two Identification Marks</label>
                <div className="identification-grid">
                  <input name="identificationMark1" placeholder="1. First identification mark" />
                  <input name="identificationMark2" placeholder="2. Second identification mark" />
                </div>
              </div>

              <div className="admission-field full-width">
                <label>19. List of Documents Attached</label>
                <div className="document-grid">
                  {[1, 2, 3, 4, 5, 6].map((number) => (
                    <div className="document-item" key={number}>
                      <span>{number}.</span>
                      <input name={`document${number}`} placeholder="Enter document name" />
                    </div>
                  ))}
                </div>
              </div>

            </div>

            {/* DECLARATION */}
            <div className="admission-declaration">
              <i className="bi bi-info-circle-fill"></i>
              <p>
                Please verify all the information entered above before
                submitting the admission form to the school office.
                Attach the applicable supporting documents.
              </p>
            </div>

            {/* OFFICE USE ONLY */}
            <div className="office-use-section">
              <div className="office-use-heading">
                <i className="bi bi-building-fill"></i>
                <h3>FOR OFFICE USE ONLY</h3>
              </div>

              <div className="admission-fields">

                <div className="admission-field">
                  <label>1. Total Dues to be Paid (In Figures) Rs.</label>
                  <input name="totalDuesFigures" placeholder="Enter amount" />
                </div>

                <div className="admission-field">
                  <label>In Words (Rupees)</label>
                  <input name="totalDuesWords" placeholder="Enter amount in words" />
                </div>

                <div className="admission-field two-column-field">
                  <div>
                    <label>2. Child Admitted to Class & Section</label>
                    <input name="admittedClass" placeholder="Class and section" />
                  </div>
                  <div>
                    <label>Vide Admission No.</label>
                    <input name="officeAdmissionNumber" placeholder="Admission number" />
                  </div>
                </div>

                <div className="admission-field two-column-field">
                  <div>
                    <label>3. All Dues Paid Vide Receipt No.</label>
                    <input name="receiptNumber" placeholder="Receipt number" />
                  </div>
                  <div>
                    <label>Date</label>
                    <input type="date" name="receiptDate" />
                  </div>
                </div>

              </div>

              <div className="office-signatures">
                <div>
                  <label>Date:</label>
                  <input type="date" name="officeDate" />
                </div>

                <div className="signature-line">
                  <span>Checked</span>
                  <div></div>
                </div>

                <div className="signature-line">
                  <span>Verified by</span>
                  <div></div>
                </div>

                <div className="signature-line principal-signature">
                  <span>Signature of Principal</span>
                  <div></div>
                </div>
              </div>

            </div>

            {/* BUTTONS */}
            <div className="admission-actions no-print">
              <button type="button" className="admission-print-btn" onClick={handlePrint}>
                <i className="bi bi-printer-fill"></i>
                Print / Save as PDF
              </button>

              <button type="reset" className="admission-reset-btn">
                <i className="bi bi-arrow-counterclockwise"></i>
                Reset Form
              </button>
            </div>

          </form>
        </div>
      </section>

    </main>
  );
}

export default AdmissionForm;
